import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  //数据
  state: {
    userMenu: [],
    record: {},
    evaluation: {},
    queryDates: [],
    curSubmenus: [],
    selectedTopMenuId: "",
    selectedSubmenuId: "",
    useTreeMap: false,
    loadGovernLevel: "",
    mapData: {
      //地图中心
      mapCenter: {
        lat: "",
        lgt: ""
      },
      //行政区信息
      area: {},
      //巡查记录
      patrolRecordList: {},
      //河流列表
      riverList: [],
      //河道列表
      reachList: []
    }
  },
  //修改数据
  mutations: {
    SET_USER_MENU(state, menus) {
      state.userMenu = menus;
    },
    SET_CUR_SUB_MENU(state, subMenus) {
      state.curSubmenus = subMenus;
    },
    SET_CUR_TOP_MENU_KEY(state, menuKey) {
      state.selectedTopMenuId = menuKey;
    },
    SET_CUR_SUB_MENU_KEY(state, menuKey) {
      state.selectedSubmenuId = menuKey;
    }
  },
  actions: {
    setUserMenu({ commit }, menus) {
      commit("SET_USER_MENU", menus);
    },
    setCurSubMenuList({ commit }, subMenus) {
      commit("SET_CUR_SUB_MENU", subMenus);
      if (!subMenus) {
        commit("SET_CUR_SUB_MENU_KEY", "");
      } else if (subMenus.length > 0) {
        commit("SET_CUR_SUB_MENU_KEY", subMenus[0].menuId);
      }
    },
    setCurTopMenuKey({ commit }, menuId) {
      commit("SET_CUR_TOP_MENU_KEY", menuId);
    },
    setCurSubMenu({ commit }, subMenuId) {
      commit("SET_CUR_SUB_MENU_KEY", subMenuId);
    },
    logoutUser({ commit }) {
      commit("SET_USER_MENU", []);
      commit("SET_CUR_SUB_MENU", []);
      commit("SET_CUR_TOP_MENU_KEY", "");
      commit("SET_CUR_SUB_MENU_KEY", "");
    },
    updateTaskCounts({ commit }, taskCounts) {
      let menus = this.state.userMenu;
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i];
        if(menu.menuId === 'mdoc') {
          menu.taskCount = taskCounts.pendingSubmittedCount + taskCounts.pendingAuditCount + taskCounts.pendingReviewCount;
          console.log('count value is set');
        }
        if(menu.subMenus && menu.subMenus.length > 0) {
          for (let j = 0; j < menu.subMenus.length; j++) {
            let subMenu = menu.subMenus[j];
            if(subMenu.menuId === 'mdoc:list') {
              subMenu.taskCount = taskCounts.pendingSubmittedCount;
              console.log('count value is set');
            }
            if(subMenu.menuId === 'mdoc:audit') {
              subMenu.taskCount = taskCounts.pendingAuditCount;
              console.log('count value is set');
            }
            if(subMenu.menuId === 'mdoc:risk') {
              subMenu.taskCount = taskCounts.pendingReviewCount;
              console.log('count value is set');
            }
          }
        }
      }
      commit("SET_USER_MENU", menus);
    }
  },
  getters: {},
  plugins: [createPersistedState()]
});
